import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api/tnsdc`,
});

// attach JWT token to every request
API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

// API calls
export const fetchBatches = () => API.get("/batches");
export const fetchCandidates = (batchId) => API.get(`/batch/${encodeURIComponent(batchId)}/candidates`);
export const updateAssessor = (data) => API.post("/update-assessor", data);
export const updateBatchStatus = (data) => API.post("/update-batch-status", data);
export const updateScore = (data) => API.post("/update-score", data);
export const savePreview = (data) => API.post("/save-preview", data);
export const getPreview = (batchCode) =>
  API.get(`/preview/${encodeURIComponent(batchCode)}`).then((r) => r.data);
